import React, { useEffect, useState } from "react";
import { kFormatter, sentimentColor } from "../../../../../redux/constants";
import { useSelector } from "react-redux";
import FB_Like from "../../../../../assets/FB_Like.svg";
import FB_like_white from "../../../../../assets/deepDive/FB_like_white.svg";
import upvote from "../../../../../assets/upvote.svg";
import upvotewhite from "../../../../../assets/upvote_white.svg";
import like from "../../../../../assets/deepDive/Like.svg";
import likewhite from "../../../../../assets/deepDive/Like_white.svg";
import comment from "../../../../../assets/deepDive/comment.svg";
import commentwhite from "../../../../../assets/deepDive/comment_white.svg";
import fb_share from "../../../../../assets/fb_share.svg";
import fb_share_white from "../../../../../assets/fb_share_white.svg";
import instaShare from "../../../../../assets/insta_share.svg";
import instaShareWhite from "../../../../../assets/insta_share_white.svg";
import Youtube_Share from "../../../../../assets/Youtube_Share.svg";
import Youtube_Share_white from "../../../../../assets/Youtube_Share_white.svg";
import reTweet from "../../../../../assets/deepDive/reTweet.svg";
import reTweetwhite from "../../../../../assets/deepDive/reTweet_white.svg";
import shareQ from "../../../../../assets/share_q.svg";
import shareQwhite from "../../../../../assets/share_q_white.svg";
import ClockIcon from "../../../../../assets/Clock_white.svg";
import Tooltip from "antd/lib/tooltip";
import isEqual from "react-fast-compare";
import { getCommandCenterIcon } from "../../../../../redux/constants/PostGalleryIcon";
import { MentionIdComponent } from "../../../../WidgetMaker/MentionIdComponent";
const CardStats = ({ cardData, index, custom_card_settings, isDetailView }) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const [footerOne, setFooterOne] = useState([]);
  const [footerTwo, setFooterTwo] = useState([]);
  const [footerThree, setFooterThree] = useState([]);
  useEffect(() => {
    if (
      custom_card_settings?.card_footer_1 &&
      Array.isArray(custom_card_settings?.card_footer_1)
    ) {
      setFooterOne(
        custom_card_settings?.card_footer_1?.map((d) =>
          d?.attribute?.toLowerCase()
        )
      );
    }
    if (
      custom_card_settings?.card_footer_2 &&
      Array.isArray(custom_card_settings?.card_footer_2)
    ) {
      setFooterTwo(
        custom_card_settings?.card_footer_2?.map((d) =>
          d?.attribute?.toLowerCase()
        )
      );
    }
    if (
      custom_card_settings?.card_footer_3 &&
      Array.isArray(custom_card_settings?.card_footer_3)
    ) {
      setFooterThree(
        custom_card_settings?.card_footer_3?.map((d) =>
          d?.attribute?.toLowerCase()
        )
      );
    }
  }, [custom_card_settings]);
  const getHtmlOfCardStats = (attributeName) => {
    if (attributeName === "numlikescount") {
      return (
        <>
          {cardData?.NumLikesCount >= 0 ? (
            <Tooltip
              title={cardData?.PlatformID === 36 ? "Upvotes" : "Likes"}
              className="stats cursor-pointer"
            >
              <div>
                <span className="stats__icon">
                  {cardData?.PlatformID === 2 || cardData?.PlatformID === 4
                    ? authParams?.theme_type === "1"
                      ? getCommandCenterIcon("facebook_like_white")
                      : getCommandCenterIcon("facebook_like")
                    : cardData?.PlatformID === 36
                    ? authParams?.theme_type === "1"
                      ? getCommandCenterIcon("upvote_white")
                      : getCommandCenterIcon("upvote")
                    : authParams?.theme_type === "1"
                    ? getCommandCenterIcon("like_white_icon")
                    : getCommandCenterIcon("like_white_icon")}
                </span>
                {/* <img
                  src={
                    cardData?.PlatformID === 2 || cardData?.PlatformID === 4
                      ? authParams?.theme_type === "1"
                        ? FB_like_white
                        : FB_Like
                      : cardData?.PlatformID === 36
                      ? authParams?.theme_type === "1"
                        ? upvotewhite
                        : upvote
                      : authParams?.theme_type === "1"
                      ? likewhite
                      : like
                  }
                  className="stats__icon"
                  alt="like"
                /> */}
                <span className="stats__count text-Darkgray">
                  {kFormatter(cardData?.NumLikesCount)}
                </span>
              </div>
            </Tooltip>
          ) : (
            ""
          )}
        </>
      );
    } else if (attributeName === "numcommentscount") {
      return (
        <>
          {cardData?.AnswerCount >= 0 || cardData?.NumCommentsCount >= 0 ? (
            <Tooltip
              title={
                cardData?.PlatformID === 36
                  ? "Answers"
                  : cardData?.PlatformID === 1
                  ? "Replies"
                  : "Comments"
              }
              className="stats cursor-pointer"
            >
              <div>
                <span className="stats__icon">
                  {authParams?.theme_type === "1"
                    ? getCommandCenterIcon("comment_white_icon")
                    : getCommandCenterIcon("comment_icon")}
                </span>

                {/* <img
                  src={authParams?.theme_type === "1" ? commentwhite : comment}
                  className="stats__icon"
                  alt="comment"
                /> */}
                <span className="stats__count text-Darkgray">
                  {cardData?.PlatformID === 36
                    ? kFormatter(cardData?.AnswerCount)
                    : kFormatter(cardData?.NumCommentsCount)}
                </span>
              </div>
            </Tooltip>
          ) : (
            ""
          )}
        </>
      );
    } else if (attributeName === "numsharecount") {
      return (
        <>
          {(cardData?.PlatformID !== 3 ||
            (cardData?.PlatformID === 3 &&
              cardData?.card_type === "Brand Post")) &&
          cardData?.NumShareCount >= 0 ? (
            <Tooltip
              title={cardData?.PlatformID === 1 ? "Retweets" : "Share"}
              className="stats cursor-pointer"
            >
              <div>
                <span className="stats__icon">
                  {cardData?.PlatformID === 2
                    ? authParams?.theme_type === "1"
                      ? getCommandCenterIcon("facebook_like_white")
                      : getCommandCenterIcon("facebook_like")
                    : cardData?.PlatformID === 4 || cardData?.PlatformID === 5
                    ? authParams?.theme_type === "1"
                      ? getCommandCenterIcon("youtube_share_white")
                      : getCommandCenterIcon("youtube_share")
                    : cardData?.PlatformID === 1
                    ? authParams?.theme_type === "1"
                      ? getCommandCenterIcon("retweet_white_icon")
                      : getCommandCenterIcon("retweet_icon")
                    : cardData?.PlatformID === 36
                    ? authParams?.theme_type === "1"
                      ? getCommandCenterIcon("share_q_white_icon")
                      : getCommandCenterIcon("share_q_icon")
                    : cardData?.PlatformID === 3
                    ? authParams?.theme_type === "1"
                      ? getCommandCenterIcon("instagram_share_white")
                      : getCommandCenterIcon("instagram_share")
                    : authParams?.theme_type === "1"
                    ? getCommandCenterIcon("youtube_share_white")
                    : getCommandCenterIcon("youtube_share")}
                </span>

                {/* <img
                  src={
                    cardData?.PlatformID === 2
                      ? authParams?.theme_type === "1"
                        ? fb_share_white
                        : fb_share
                      : cardData?.PlatformID === 4 || cardData?.PlatformID === 5
                      ? authParams?.theme_type === "1"
                        ? Youtube_Share_white
                        : Youtube_Share
                      : cardData?.PlatformID === 1
                      ? authParams?.theme_type === "1"
                        ? reTweetwhite
                        : reTweet
                      : cardData?.PlatformID === 36
                      ? authParams?.theme_type === "1"
                        ? shareQwhite
                        : shareQ
                      : cardData?.PlatformID === 3
                      ? authParams?.theme_type === "1"
                        ? instaShareWhite
                        : instaShare
                      : authParams?.theme_type === "1"
                      ? Youtube_Share_white
                      : Youtube_Share
                  }
                  className="stats__icon"
                  alt={cardData?.PlatformID === 1 ? "Retweet" : "Shares"}
                /> */}
                <span className="stats__count text-Darkgray">
                  {kFormatter(cardData?.NumShareCount)}
                </span>
              </div>
            </Tooltip>
          ) : (
            ""
          )}
        </>
      );
    } else if (attributeName === "url") {
      return (
        <>
          {
            <Tooltip
              title={
                cardData?.PostURL &&
                cardData?.PostURL?.trim() &&
                cardData?.PostURL !== "NA"
                  ? "Open Post"
                  : "Post URL is not available"
              }
              className="stats cursor-pointer"
            >
              {cardData?.PostURL &&
              cardData?.PostURL?.trim() &&
              cardData?.PostURL !== "NA" ? (
                <a
                  className={`trands blue-text font-size14 cursor-pointer mr-2`}
                  href={cardData?.PostURL}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class={`fas fa-external-link-alt`} />
                </a>
              ) : (
                <span
                  style={{ display: "inline-block", opacity: "0.4" }}
                  className="blue-text font-size14 mr-2"
                >
                  <i class={`fas fa-external-link-alt`} />
                </span>
              )}
            </Tooltip>
          }
        </>
      );
    } else if (attributeName === "createddate") {
      return (
        <>
          {cardData?.CreatedDate ? (
            <>
              <MentionIdComponent
                color={cardData?.SentimentType}
                id={cardData?.mention_id}
                className="stats-mention-id-component"
              />
              <Tooltip
                title={
                  <div>
                    Created Date : <br />{" "}
                    {cardData?.CreatedDate_tooltip
                      ? cardData?.CreatedDate_tooltip
                      : cardData?.CreatedDate}
                  </div>
                }
                className="stats cursor-pointer no--wrap d-flex align-items-center"
              >
                <span>{getCommandCenterIcon("clock_icon")}</span>
                <span className="stats__count text-grayLight">
                  {cardData?.CreatedDate}
                </span>
              </Tooltip>
            </>
          ) : (
            ""
          )}
        </>
      );
    }
    return "";
  };
  return (
    <>
      {footerOne?.length > 0 ? (
        <div className="stats__wrapper">
          {footerOne?.map((attributeName) => {
            return getHtmlOfCardStats(attributeName);
          })}
        </div>
      ) : (
        ""
      )}
      {/* {footerTwo?.length > 0 ? (
        <div className="stats__wrapper">
          {footerTwo?.map((attributeName) => {
            return getHtmlOfCardStats(attributeName);
          })}
        </div>
      ) : (
        ""
      )} */}
      {footerThree?.length > 0 ? (
        <div className=" stats__wrapper">
          <MentionIdComponent
            color={cardData?.SentimentType}
            id={cardData?.mention_id}
          />
          {footerThree?.map((attributeName) => {
            return getHtmlOfCardStats(attributeName);
          })}
          {cardData?.IsDeletedFromSocial ? (
            <Tooltip
              title={<div>Deleted From Social</div>}
              className="stats cursor-pointer no--wrap d-flex align-items-center"
            >
              <i className="fas fa-trash-alt stats__icon trash__icon"></i>
              <span className="stats__count text-grayLight">
                {"Deleted Post"}
              </span>
            </Tooltip>
          ) : (
            ""
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default React.memo(CardStats, isEqual);
